// src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/user/userSlice";
import wishListReducer from "../features/wishList/wishListSlice";

export default configureStore({
  reducer: { user: userReducer, wishList: wishListReducer },
});
